import { Control, Controller } from "react-hook-form";

import { FormInput } from "~/screens/Scheduling/PersonalInformation/components/form-input";
import { adminProviders } from "~/services";

type UploadProviderScheduleParams = adminProviders.UploadProviderScheduleParams;

type Props = {
  control: Control<UploadProviderScheduleParams>;
};

export const EditProviderScheduleDescriptionField = ({ control }: Props) => (
  <Controller
    name="description"
    control={control}
    render={({ field, fieldState }) => (
      <FormInput
        label="Schedule description (optional)"
        name={field.name}
        type="textarea"
        value={field.value ?? ""}
        onChange={field.onChange}
        onBlur={field.onBlur}
        placeholder="Add details about this schedule"
        error={fieldState.error?.message}
      />
    )}
  />
);
